import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc1562c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "U kunt deze route gratis downloaden als u uw e-mailadres opgeeft. Het e-mailadres zullen wij uitsluitend gebruiken om u eenmalig naar uw ervaring te vragen en een kennismakingsaanbod te doen om abonnee te worden van De Mooiste Routes.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Wilt u uw e-mailadres niet achterlaten, klik dan op "),
  /*#__PURE__*/_createElementVNode("em", null, "sluiten"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_4 = { for: "email" }
const _hoisted_5 = { class: "error" }
const _hoisted_6 = { class: "controlrow edit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "css-label",
  for: "emailaddressconsent"
}, " Ik ben akkoord met het gebruik van mijn e-mailadres.", -1))
const _hoisted_8 = {
  id: "confirm",
  class: "mrbox",
  style: {"height":"44px"}
}
const _hoisted_9 = {
  class: "bottombar",
  style: {"text-align":"left","left":"8px"}
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Controleer uw email voor de verificatiecode.", -1))
const _hoisted_12 = { for: "verificationcode" }
const _hoisted_13 = { class: "controlrow edit" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "confirmverfication",
  class: "mrbox",
  style: {"height":"44px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bottombar",
    style: {"text-align":"left","left":"8px"}
  }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "button lightfill"
    }, "Bevestig")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.trail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showEmailInput)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
              class: "mrbox round border darkfill"
            }, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("label", _hoisted_4, [
                _createTextVNode(" e-mailadres "),
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.invalidEmail), 1),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "e-mailadres",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.email]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "emailaddressconsent",
                class: "css-checkbox",
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emailaddressconsent) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.emailaddressconsent]
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "button lightfill",
                    disabled: !_ctx.emailaddressconsent
                  }, " Bevestig", 8, _hoisted_10)
                ])
              ])
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.showValidationInput)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmitVerification && _ctx.onSubmitVerification(...args))),
              class: "mrbox round border darkfill"
            }, [
              _hoisted_11,
              _createElementVNode("div", null, _toDisplayString(_ctx.usermessage), 1),
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode(" Verificatiecode "),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Verificatiecode",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.verificationcode) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.verificationcode]
                  ])
                ])
              ]),
              _hoisted_14
            ], 32))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}